import { callCommonApi } from "./callCommonApi";

// 🔐 인증 (Auth) / 관리자 로그인
// 환경에 따른 API 호스트 결정
const getApiHost = () => {
  // 브라우저 환경에서 프로토콜 확인
  if (typeof window !== 'undefined') {
    const isHttps = window.location.protocol === 'https:';
    if (!isHttps) {
      // HTTP 환경 (테스트 서버)
      return process.env.REACT_APP_API_DEV_URL;
    } else {
      // HTTPS 환경 (운영 서버)
      return process.env.REACT_APP_API_PROD_URL;
    }
  }
  
  // 서버사이드에서는 기본값 사용
  return process.env.REACT_APP_API_HOST;
};

export async function uploadCommonFile(formData: FormData, isCallPageLoader: boolean = true) {
  return callCommonApi({
    title: "Common File Upload",
    url: `${getApiHost()}/api/upload`,
    formData,
    isCallPageLoader,
  });
}

// 에디터 이미지 업로드 (여러 파일)
export async function uploadEditorImages(files: File[]) {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append('file', file);
  });
  
  return callCommonApi({
    title: "Editor Images Upload",
    url: `${getApiHost()}/api/upload`,
    formData,
    isCallPageLoader: true,
  });
}

// 에디터 콘텐츠 처리 (blob URL을 서버 URL로 변환)
export async function processEditorContent(content: string, uploadedFiles: any[]): Promise<string> {
  let processedContent = content;
  
  // blob URL들을 찾아서 서버 파일명으로 교체
  const blobUrls = content.match(/src="blob:[^"]+"/g) || [];
  
  for (let i = 0; i < blobUrls.length && i < uploadedFiles.length; i++) {
    const blobUrl = blobUrls[i].replace('src="', '').replace('"', '');
    const uploadedFile = uploadedFiles[i];
    const fileName = typeof uploadedFile === 'string' ? uploadedFile : uploadedFile?.fileName || uploadedFile?.index;
    
    if (fileName) {
      const serverUrl = `${getApiHost()}/${fileName}`;
      processedContent = processedContent.replace(blobUrl, serverUrl);
    }
  }
  
  return processedContent;
}
